import React from "react";
import styles from "./RadioGroup.module.sass";
import Input, { inputType } from "../Input/Input";

const radioGroup = props => {
  const onChangeHandler = value => {
    if (props.hasOwnProperty("onChanged") && !props.readonly) {
      props.onChanged(value);
    }
  };

  return (
    <div className={styles.RadioGroup + (props.column ? " flex-column" : "")}>
      {props.options.map((el, index) => (
        <Input
          onSelected={() => onChangeHandler(el.value)}
          key={index}
          selected={el.value === props.value}
          type={inputType.RADIO}
          icon={el.icon}
        >
          {el.textBold ? <b>{el.text ? el.text : el.value}</b> : el.text ? el.text : el.value}
          {el.textDetails && <span>{el.textDetails}</span> }
        </Input>
      ))}
    </div>
  );
};

export default radioGroup;
